import { useLocaleState, useRecordContext } from "react-admin";

import LabelField from "../../unit/LabelField";

const AcceptLog = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  return (
    <>
      <LabelField
        title="Data Accepted"
        value={record.created_at}
        format="date"
        prefix="EST"
      />
      <LabelField title="Accepted By" value={record.sOper} />
      {record.sComment && record.sComment.length > 0 ? (
        <LabelField title="Comment" value={record.sComment} format="richtext" />
      ) : (
        <></>
      )}
    </>
  );
};

export default AcceptLog;
